import { FETCH_ADMIN_USER, DESTROY_ADMIN_USER } from "../actionTypes";

const fetchUsers = (state = [], action) => {
  switch (action.type) {
    case FETCH_ADMIN_USER:
      state = [];
      return [...state, ...action.users];

    case DESTROY_ADMIN_USER:
      return state[action.key] = [];
      
    default:
      return state;
  }
};

export default fetchUsers;
